export function crearApi(vm) {
  const base = (vm.$hostname || '') + (vm.$hName || '') + '/transporte-utilitario';
  const headers = () => vm.$store && vm.$store.getters && vm.$store.getters.GetheadersAxios || {};
  // El interceptor general convierte `fecha` en fecha-hora; el utilitario usa fechas sin hora.
  const post = (path, body, timeout = 30000) => vm.$axios.post(base + path, JSON.stringify(body), {
    headers: { ...headers(), 'Content-Type': 'application/json' }, timeout,
  }).then(r => r.data);
  return {
    contexto: () => vm.$axios.get(base + '/contexto', { headers: headers(), timeout: 30000 }).then(r => r.data),
    consulta: (vista, filtros) => post('/consulta/' + encodeURIComponent(vista), filtros),
    detalle: (vista, id, filtros = {}) => vm.$axios.get(base + '/detalle/' + encodeURIComponent(vista) + '/' + encodeURIComponent(id), {
      headers: headers(), params: filtros, timeout: 30000,
    }).then(r => r.data),
    accion: (accion, datos) => post('/accion/' + encodeURIComponent(accion), datos, ['ticket-cancelar', 'envio-cancelar'].includes(accion) ? 180000 : 30000),
    impresion: (vista, datos) => post('/impresion/' + encodeURIComponent(vista), datos),
    reportePdf: (vista, datos) => vm.$axios.post(base + '/reportes/' + encodeURIComponent(vista) + '/pdf', JSON.stringify(datos), {
      headers: { ...headers(), 'Content-Type': 'application/json' }, responseType: 'blob', timeout: 120000,
    }).then(r => r.data),
    notaCreditoPdf: id => vm.$axios.get(base + '/notas-credito/pdf/' + encodeURIComponent(id), {
      headers: headers(), responseType: 'blob', timeout: 90000,
    }).then(r => r.data),
    auditoria: pagina => vm.$axios.get(base + '/auditoria', { headers: headers(), params: { pagina }, timeout: 30000 }).then(r => r.data),
    headers,
  };
}
export function ajustesImpresora(storage) {
  try {
    const caja = JSON.parse(storage.getItem('pvt_configuracion_caja') || '{}');
    const printer = JSON.parse(storage.getItem('printerSelect') || '{}');
    return caja.impresoraTickets || printer.nombre || '';
  } catch (e) { return ''; }
}
export async function listarImpresoras(axios) {
  let ultimo;
  for (const host of ['http://localhost:15999', 'http://127.0.0.1:15999']) {
    try {
      const res = await axios.get(host + '/impresora/inicial/listaImpresora', { timeout: 5000 });
      const terminal = Array.isArray(res.data) ? res.data[0] : null;
      if (!terminal || !Array.isArray(terminal.impresoras)) throw new Error('El servicio local no devolvio la lista de impresoras de Windows.');
      return { impresoras: terminal.impresoras.filter(i => typeof i.nombre === 'string'), predeterminada: terminal.defaulPrinter || terminal.defaultPrinter || '' };
    } catch (error) { ultimo = error; }
  }
  throw ultimo;
}
export function tiempoEsperaImpresion(datos) {
  if (datos.operacion !== 'boleto-transporte') return 60000;
  const copias = n => Number.isFinite(Number(n)) ? Math.max(0, Math.trunc(Number(n))) : 0;
  const cantidad = Array.isArray(datos.boletos) ? Math.max(1, datos.boletos.length) : 1;
  const pequeno = datos.imprimirPequeno === undefined || String(datos.imprimirPequeno).toLowerCase() === 'true';
  return Math.min(600000, 60000 + cantidad * (1 + copias(datos.copias) + (pequeno ? 2 + copias(datos.copiasPequeno) : 0)) * 60000);
}
export async function postImpresoraLocal(axios, datos) {
  let ultimo;
  for (const host of ['http://localhost:15999', 'http://127.0.0.1:15999']) {
    try {
      const respuesta = await axios.post(host + '/impresora/imprimir', datos, { timeout: tiempoEsperaImpresion(datos) });
      const avisos = respuesta.data && respuesta.data.advertencias;
      if (Array.isArray(avisos) && avisos.length) window.alert(avisos.join('\n\n'));
      return respuesta;
    }
    catch (error) {
      ultimo = error;
      // Igual que el POS: una respuesta o un timeout nunca se reintentan en otro host.
      if (error.response || ['ECONNABORTED', 'ETIMEDOUT'].includes(error.code)) throw error;
    }
  }
  throw ultimo;
}
